<template>
  <transition name="fade">
    <div v-show="zoomImgObj.show">
      <div class="maskLayer" v-tap.prevent="{ methods : closeZoomImg}"></div>
      <img class="zoomImg" ref="zoomImg" :src="zoomImgObj.url" :style="styleObject"/>
    </div>
  </transition>
</template>
<script>
  import {mapState} from 'vuex';
  export default {
    name: 'zoomImg',
    data(){
      return {
        startTouchXY: [],
        moveTouchXY: [],
        moveLeft: 0,
        moveTop: 0,
        scale: 1
      };
    },
    computed: {
      ...mapState({zoomImgObj: 'zoomImgObj'}),
      styleObject(){
        const imgObj = this.zoomImgObj;
        let width = imgObj.width;
        let height = imgObj.height;
        const ratio = width / height;
        const maxWidth = window.innerWidth * 4 / 5;
        const maxHeight = window.innerHeight * 4 / 5;
        if (maxHeight >= maxWidth / ratio) {
          width = maxWidth;
          height = maxWidth / ratio;
        } else {
          height = maxHeight;
          width = maxHeight * ratio;
        }
        let _width = width * this.scale;
        let _height = height * this.scale;
        let _marginLeft = _width * (-0.5) + this.moveLeft;
        let _marginTop = _height * (-0.5) + this.moveTop;
        return {width: _width + 'px', height: _height + 'px', marginLeft: _marginLeft + 'px', marginTop: _marginTop + 'px'};
      }
    },
    methods: {
      touchChange(changedTouches){
        if (this.startTouchXY.length < 2) {
          if (changedTouches.length === 1) {
            this.startTouchXY.pop();
            this.startTouchXY.push(changedTouches[0]);
          } else if (changedTouches.length > 1) {
            this.startTouchXY.pop();
            this.startTouchXY.push(changedTouches[0]);
            this.startTouchXY.push(changedTouches[1]);
          }
        } else {
          if (changedTouches.length > 1) {
            this.moveTouchXY.pop();
            this.moveTouchXY.pop();
            this.moveTouchXY.push(changedTouches[0]);
            this.moveTouchXY.push(changedTouches[1]);
          }
        }
        this.setImageStyle();
      },
      setImageStyle(){
        let startTouchXY = this.startTouchXY;
        let moveTouchXY = this.moveTouchXY;
        if (startTouchXY.length > 1 && moveTouchXY.length > 1) {
          let startXY = Math.sqrt(Math.pow(startTouchXY[0].screenX - startTouchXY[1].screenX, 2) + Math.pow(startTouchXY[0].screenY - startTouchXY[1].screenY, 2));
          let moveXY = Math.sqrt(Math.pow(moveTouchXY[0].screenX - moveTouchXY[1].screenX, 2) + Math.pow(moveTouchXY[0].screenY - moveTouchXY[1].screenY, 2));
          if (Math.abs(moveXY - startXY) > 10) {
            let scale = moveXY / startXY;
            scale = scale * this.scale;
            this.scale = scale;
            startTouchXY[0] = moveTouchXY[0];
            startTouchXY[1] = moveTouchXY[1];
            //this.$refs.zoomImg.style.transform = `scale3d(${scale},${scale},${scale})`;
            this.$refs.zoomImg.style.transform = `scale(${scale},${scale})`;
            /*let moveCenterX = (moveTouchXY[0].screenX + moveTouchXY[1].screenX) / 2;
             let moveCenterY = (moveTouchXY[0].screenY + moveTouchXY[1].screenY) / 2;
             let screenCenterX = window.innerWidth / 2;
             let screenCenterY = window.innerHeight / 2;
             this.moveLeft = moveCenterX - screenCenterX;
             this.moveTop = moveCenterY - screenCenterY;
             this.$refs.zoomImg.style.marginLeft = this.styleObject.marginLeft;
             this.$refs.zoomImg.style.marginTop = this.styleObject.marginTop;*/
          }
        }
      },
      closeZoomImg(){
        this.zoomImgObj.show = false;
        setTimeout(() => {
          this.startTouchXY = [];
          this.moveTouchXY = [];
          this.scale = 1;
          this.moveLeft = 0;
          this.moveTop = 0;
          this.$refs.zoomImg.style.transform = null;
//          this.$refs.zoomImg.style.marginLeft = '0';
//          this.$refs.zoomImg.style.marginTop = '0';
        }, 500);
      }
    },
    mounted(){
      var startTouchXY = [0, 0];
      var moveTouchXY = [0, 0];
      this.$refs.zoomImg.ontouchstart = (event) => {
        event.preventDefault();
        this.startTouchXY = [];
        this.moveTouchXY = [];
        this.touchChange(event.changedTouches);
        startTouchXY[0] = event.changedTouches[0].screenX;
        startTouchXY[1] = event.changedTouches[0].screenY;
        moveTouchXY[0] = this.moveLeft;
        moveTouchXY[1] = this.moveTop;
      };
      this.$refs.zoomImg.ontouchmove = (event) => {
        event.preventDefault();
        this.touchChange(event.changedTouches);
        if (event.changedTouches.length === 1) {
          var moveX = event.changedTouches[0].screenX;
          var moveY = event.changedTouches[0].screenY;
          moveX = moveX - startTouchXY[0];
          moveY = moveY - startTouchXY[1];
          if (Math.abs(moveX) > 30 || Math.abs(moveY) > 30) {
            this.moveLeft = moveTouchXY[0] + moveX;
            this.moveTop = moveTouchXY[1] + moveY;
            this.$refs.zoomImg.style.marginLeft = this.styleObject.marginLeft;
            this.$refs.zoomImg.style.marginTop = this.styleObject.marginTop;
          }
        }
      };
    }
  }
</script>
<style scoped lang="less">
  .maskLayer {
    position: fixed;
    left: 0;
    bottom: 0;
    top: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 100;
  }

  .zoomImg {
    position: fixed;
    left: 50%;
    top: 50%;
    z-index: 110;
    background: center center no-repeat;
    background-size: contain;
    box-shadow: 0px 0px 12px 0px #999;
    border-radius: 4px;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s
  }

  .fade-enter, .fade-leave-to {
    opacity: 0
  }
</style>



// WEBPACK FOOTER //
// zoomImg.vue?2ce19af2